import { render, staticRenderFns } from "./store-edit-new.vue?vue&type=template&id=ba4f3e2c&scoped=true"
import script from "./store-edit-new.vue?vue&type=script&lang=ts"
export * from "./store-edit-new.vue?vue&type=script&lang=ts"
import style0 from "./store-edit-new.vue?vue&type=style&index=0&id=ba4f3e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4f3e2c",
  null
  
)

export default component.exports